/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PublicTermsOfServiceRouteImport } from './routes/_public/terms-of-service'
import { Route as PublicPrivacyPolicyRouteImport } from './routes/_public/privacy-policy'
import { Route as PublicDataDeletionAgreementRouteImport } from './routes/_public/data-deletion-agreement'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAccountRouteImport } from './routes/_authed/account'
import { Route as AuthedProfessionalRouteImport } from './routes/_authed/_professional'
import { Route as AuthedIndividualRouteImport } from './routes/_authed/_individual'
import { Route as PublicSignUpIndexRouteImport } from './routes/_public/sign-up/index'
import { Route as PublicSignInIndexRouteImport } from './routes/_public/sign-in/index'
import { Route as PublicHomepageIndexRouteImport } from './routes/_public/_homepage/index'
import { Route as AuthedOnboardingEmergencyContactsRouteImport } from './routes/_authed/onboarding/emergency-contacts'
import { Route as AuthedInvitationTokenRouteImport } from './routes/_authed/invitation/$token'
import { Route as AuthedAccountSecurityRouteImport } from './routes/_authed/account/security'
import { Route as AuthedAccountProfileRouteImport } from './routes/_authed/account/profile'
import { Route as AuthedAccountOrganizationRouteImport } from './routes/_authed/account/organization'
import { Route as AuthedAccountEmergencyContactsRouteImport } from './routes/_authed/account/emergency-contacts'
import { Route as PublicSignUpProIndexRouteImport } from './routes/_public/sign-up/pro/index'
import { Route as AuthedProfessionalProfessionalInvitationsRouteImport } from './routes/_authed/_professional/professional/invitations'
import { Route as AuthedProfessionalProfessionalClientsRouteImport } from './routes/_authed/_professional/professional/clients'
import { Route as AuthedProfessionalProfessionalBillingRouteImport } from './routes/_authed/_professional/professional/billing'
import { Route as AuthedIndividualPersonalJournalsRouteImport } from './routes/_authed/_individual/personal/journals'
import { Route as AuthedIndividualPersonalJournalManagementRouteImport } from './routes/_authed/_individual/personal/journal-management'
import { Route as AuthedIndividualPersonalJournalInvitationsRouteImport } from './routes/_authed/_individual/personal/journal-invitations'
import { Route as AuthedIndividualPersonalGuidedFormsRouteImport } from './routes/_authed/_individual/personal/guided-forms'
import { Route as AuthedIndividualPersonalGoalsRouteImport } from './routes/_authed/_individual/personal/goals'
import { Route as AuthedIndividualPersonalDocumentsRouteImport } from './routes/_authed/_individual/personal/documents'
import { Route as AuthedIndividualPersonalDashboardRouteImport } from './routes/_authed/_individual/personal/dashboard'
import { Route as AuthedIndividualPersonalCollaboratorsRouteImport } from './routes/_authed/_individual/personal/collaborators'
import { Route as AuthedIndividualPersonalCollaborationRequestsRouteImport } from './routes/_authed/_individual/personal/collaboration-requests'
import { Route as AuthedProfessionalProfessionalReportsEstateIdRouteImport } from './routes/_authed/_professional/professional/reports/$estateId'
import { Route as AuthedProfessionalProfessionalOverviewEstateIdRouteImport } from './routes/_authed/_professional/professional/overview/$estateId'
import { Route as AuthedProfessionalProfessionalGuidedFormsEstateIdRouteImport } from './routes/_authed/_professional/professional/guided-forms/$estateId'
import { Route as AuthedProfessionalProfessionalGoalsEstateIdRouteImport } from './routes/_authed/_professional/professional/goals/$estateId'
import { Route as AuthedIndividualPersonalJournalInvitationsAcceptRouteImport } from './routes/_authed/_individual/personal/journal-invitations.accept'
import { Route as AuthedProfessionalProfessionalReportsWillEstateIdRouteImport } from './routes/_authed/_professional/professional/reports/will/$estateId'
import { Route as AuthedProfessionalProfessionalReportsTrustEstateIdRouteImport } from './routes/_authed/_professional/professional/reports/trust/$estateId'
import { Route as AuthedProfessionalProfessionalReportsInsuranceEstateIdRouteImport } from './routes/_authed/_professional/professional/reports/insurance/$estateId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTermsOfServiceRoute = PublicTermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDataDeletionAgreementRoute =
  PublicDataDeletionAgreementRouteImport.update({
    id: '/data-deletion-agreement',
    path: '/data-deletion-agreement',
    getParentRoute: () => PublicRoute,
  } as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfessionalRoute = AuthedProfessionalRouteImport.update({
  id: '/_professional',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIndividualRoute = AuthedIndividualRouteImport.update({
  id: '/_individual',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicSignUpIndexRoute = PublicSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInIndexRoute = PublicSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicHomepageIndexRoute = PublicHomepageIndexRouteImport.update({
  id: '/_homepage/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedOnboardingEmergencyContactsRoute =
  AuthedOnboardingEmergencyContactsRouteImport.update({
    id: '/onboarding/emergency-contacts',
    path: '/onboarding/emergency-contacts',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedInvitationTokenRoute = AuthedInvitationTokenRouteImport.update({
  id: '/invitation/$token',
  path: '/invitation/$token',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountSecurityRoute = AuthedAccountSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthedAccountRoute,
} as any)
const AuthedAccountProfileRoute = AuthedAccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedAccountRoute,
} as any)
const AuthedAccountOrganizationRoute =
  AuthedAccountOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthedAccountRoute,
  } as any)
const AuthedAccountEmergencyContactsRoute =
  AuthedAccountEmergencyContactsRouteImport.update({
    id: '/emergency-contacts',
    path: '/emergency-contacts',
    getParentRoute: () => AuthedAccountRoute,
  } as any)
const PublicSignUpProIndexRoute = PublicSignUpProIndexRouteImport.update({
  id: '/sign-up/pro/',
  path: '/sign-up/pro/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedProfessionalProfessionalInvitationsRoute =
  AuthedProfessionalProfessionalInvitationsRouteImport.update({
    id: '/professional/invitations',
    path: '/professional/invitations',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalClientsRoute =
  AuthedProfessionalProfessionalClientsRouteImport.update({
    id: '/professional/clients',
    path: '/professional/clients',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalBillingRoute =
  AuthedProfessionalProfessionalBillingRouteImport.update({
    id: '/professional/billing',
    path: '/professional/billing',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedIndividualPersonalJournalsRoute =
  AuthedIndividualPersonalJournalsRouteImport.update({
    id: '/personal/journals',
    path: '/personal/journals',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalJournalManagementRoute =
  AuthedIndividualPersonalJournalManagementRouteImport.update({
    id: '/personal/journal-management',
    path: '/personal/journal-management',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalJournalInvitationsRoute =
  AuthedIndividualPersonalJournalInvitationsRouteImport.update({
    id: '/personal/journal-invitations',
    path: '/personal/journal-invitations',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalGuidedFormsRoute =
  AuthedIndividualPersonalGuidedFormsRouteImport.update({
    id: '/personal/guided-forms',
    path: '/personal/guided-forms',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalGoalsRoute =
  AuthedIndividualPersonalGoalsRouteImport.update({
    id: '/personal/goals',
    path: '/personal/goals',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalDocumentsRoute =
  AuthedIndividualPersonalDocumentsRouteImport.update({
    id: '/personal/documents',
    path: '/personal/documents',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalDashboardRoute =
  AuthedIndividualPersonalDashboardRouteImport.update({
    id: '/personal/dashboard',
    path: '/personal/dashboard',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalCollaboratorsRoute =
  AuthedIndividualPersonalCollaboratorsRouteImport.update({
    id: '/personal/collaborators',
    path: '/personal/collaborators',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedIndividualPersonalCollaborationRequestsRoute =
  AuthedIndividualPersonalCollaborationRequestsRouteImport.update({
    id: '/personal/collaboration-requests',
    path: '/personal/collaboration-requests',
    getParentRoute: () => AuthedIndividualRoute,
  } as any)
const AuthedProfessionalProfessionalReportsEstateIdRoute =
  AuthedProfessionalProfessionalReportsEstateIdRouteImport.update({
    id: '/professional/reports/$estateId',
    path: '/professional/reports/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalOverviewEstateIdRoute =
  AuthedProfessionalProfessionalOverviewEstateIdRouteImport.update({
    id: '/professional/overview/$estateId',
    path: '/professional/overview/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalGuidedFormsEstateIdRoute =
  AuthedProfessionalProfessionalGuidedFormsEstateIdRouteImport.update({
    id: '/professional/guided-forms/$estateId',
    path: '/professional/guided-forms/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalGoalsEstateIdRoute =
  AuthedProfessionalProfessionalGoalsEstateIdRouteImport.update({
    id: '/professional/goals/$estateId',
    path: '/professional/goals/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedIndividualPersonalJournalInvitationsAcceptRoute =
  AuthedIndividualPersonalJournalInvitationsAcceptRouteImport.update({
    id: '/accept',
    path: '/accept',
    getParentRoute: () => AuthedIndividualPersonalJournalInvitationsRoute,
  } as any)
const AuthedProfessionalProfessionalReportsWillEstateIdRoute =
  AuthedProfessionalProfessionalReportsWillEstateIdRouteImport.update({
    id: '/professional/reports/will/$estateId',
    path: '/professional/reports/will/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalReportsTrustEstateIdRoute =
  AuthedProfessionalProfessionalReportsTrustEstateIdRouteImport.update({
    id: '/professional/reports/trust/$estateId',
    path: '/professional/reports/trust/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)
const AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute =
  AuthedProfessionalProfessionalReportsInsuranceEstateIdRouteImport.update({
    id: '/professional/reports/insurance/$estateId',
    path: '/professional/reports/insurance/$estateId',
    getParentRoute: () => AuthedProfessionalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/account': typeof AuthedAccountRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/data-deletion-agreement': typeof PublicDataDeletionAgreementRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/terms-of-service': typeof PublicTermsOfServiceRoute
  '/account/emergency-contacts': typeof AuthedAccountEmergencyContactsRoute
  '/account/organization': typeof AuthedAccountOrganizationRoute
  '/account/profile': typeof AuthedAccountProfileRoute
  '/account/security': typeof AuthedAccountSecurityRoute
  '/invitation/$token': typeof AuthedInvitationTokenRoute
  '/onboarding/emergency-contacts': typeof AuthedOnboardingEmergencyContactsRoute
  '/': typeof PublicHomepageIndexRoute
  '/sign-in': typeof PublicSignInIndexRoute
  '/sign-up': typeof PublicSignUpIndexRoute
  '/personal/collaboration-requests': typeof AuthedIndividualPersonalCollaborationRequestsRoute
  '/personal/collaborators': typeof AuthedIndividualPersonalCollaboratorsRoute
  '/personal/dashboard': typeof AuthedIndividualPersonalDashboardRoute
  '/personal/documents': typeof AuthedIndividualPersonalDocumentsRoute
  '/personal/goals': typeof AuthedIndividualPersonalGoalsRoute
  '/personal/guided-forms': typeof AuthedIndividualPersonalGuidedFormsRoute
  '/personal/journal-invitations': typeof AuthedIndividualPersonalJournalInvitationsRouteWithChildren
  '/personal/journal-management': typeof AuthedIndividualPersonalJournalManagementRoute
  '/personal/journals': typeof AuthedIndividualPersonalJournalsRoute
  '/professional/billing': typeof AuthedProfessionalProfessionalBillingRoute
  '/professional/clients': typeof AuthedProfessionalProfessionalClientsRoute
  '/professional/invitations': typeof AuthedProfessionalProfessionalInvitationsRoute
  '/sign-up/pro': typeof PublicSignUpProIndexRoute
  '/personal/journal-invitations/accept': typeof AuthedIndividualPersonalJournalInvitationsAcceptRoute
  '/professional/goals/$estateId': typeof AuthedProfessionalProfessionalGoalsEstateIdRoute
  '/professional/guided-forms/$estateId': typeof AuthedProfessionalProfessionalGuidedFormsEstateIdRoute
  '/professional/overview/$estateId': typeof AuthedProfessionalProfessionalOverviewEstateIdRoute
  '/professional/reports/$estateId': typeof AuthedProfessionalProfessionalReportsEstateIdRoute
  '/professional/reports/insurance/$estateId': typeof AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute
  '/professional/reports/trust/$estateId': typeof AuthedProfessionalProfessionalReportsTrustEstateIdRoute
  '/professional/reports/will/$estateId': typeof AuthedProfessionalProfessionalReportsWillEstateIdRoute
}
export interface FileRoutesByTo {
  '/account': typeof AuthedAccountRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/data-deletion-agreement': typeof PublicDataDeletionAgreementRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/terms-of-service': typeof PublicTermsOfServiceRoute
  '/account/emergency-contacts': typeof AuthedAccountEmergencyContactsRoute
  '/account/organization': typeof AuthedAccountOrganizationRoute
  '/account/profile': typeof AuthedAccountProfileRoute
  '/account/security': typeof AuthedAccountSecurityRoute
  '/invitation/$token': typeof AuthedInvitationTokenRoute
  '/onboarding/emergency-contacts': typeof AuthedOnboardingEmergencyContactsRoute
  '/': typeof PublicHomepageIndexRoute
  '/sign-in': typeof PublicSignInIndexRoute
  '/sign-up': typeof PublicSignUpIndexRoute
  '/personal/collaboration-requests': typeof AuthedIndividualPersonalCollaborationRequestsRoute
  '/personal/collaborators': typeof AuthedIndividualPersonalCollaboratorsRoute
  '/personal/dashboard': typeof AuthedIndividualPersonalDashboardRoute
  '/personal/documents': typeof AuthedIndividualPersonalDocumentsRoute
  '/personal/goals': typeof AuthedIndividualPersonalGoalsRoute
  '/personal/guided-forms': typeof AuthedIndividualPersonalGuidedFormsRoute
  '/personal/journal-invitations': typeof AuthedIndividualPersonalJournalInvitationsRouteWithChildren
  '/personal/journal-management': typeof AuthedIndividualPersonalJournalManagementRoute
  '/personal/journals': typeof AuthedIndividualPersonalJournalsRoute
  '/professional/billing': typeof AuthedProfessionalProfessionalBillingRoute
  '/professional/clients': typeof AuthedProfessionalProfessionalClientsRoute
  '/professional/invitations': typeof AuthedProfessionalProfessionalInvitationsRoute
  '/sign-up/pro': typeof PublicSignUpProIndexRoute
  '/personal/journal-invitations/accept': typeof AuthedIndividualPersonalJournalInvitationsAcceptRoute
  '/professional/goals/$estateId': typeof AuthedProfessionalProfessionalGoalsEstateIdRoute
  '/professional/guided-forms/$estateId': typeof AuthedProfessionalProfessionalGuidedFormsEstateIdRoute
  '/professional/overview/$estateId': typeof AuthedProfessionalProfessionalOverviewEstateIdRoute
  '/professional/reports/$estateId': typeof AuthedProfessionalProfessionalReportsEstateIdRoute
  '/professional/reports/insurance/$estateId': typeof AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute
  '/professional/reports/trust/$estateId': typeof AuthedProfessionalProfessionalReportsTrustEstateIdRoute
  '/professional/reports/will/$estateId': typeof AuthedProfessionalProfessionalReportsWillEstateIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authed/_individual': typeof AuthedIndividualRouteWithChildren
  '/_authed/_professional': typeof AuthedProfessionalRouteWithChildren
  '/_authed/account': typeof AuthedAccountRouteWithChildren
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_public/data-deletion-agreement': typeof PublicDataDeletionAgreementRoute
  '/_public/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/_public/terms-of-service': typeof PublicTermsOfServiceRoute
  '/_authed/account/emergency-contacts': typeof AuthedAccountEmergencyContactsRoute
  '/_authed/account/organization': typeof AuthedAccountOrganizationRoute
  '/_authed/account/profile': typeof AuthedAccountProfileRoute
  '/_authed/account/security': typeof AuthedAccountSecurityRoute
  '/_authed/invitation/$token': typeof AuthedInvitationTokenRoute
  '/_authed/onboarding/emergency-contacts': typeof AuthedOnboardingEmergencyContactsRoute
  '/_public/_homepage/': typeof PublicHomepageIndexRoute
  '/_public/sign-in/': typeof PublicSignInIndexRoute
  '/_public/sign-up/': typeof PublicSignUpIndexRoute
  '/_authed/_individual/personal/collaboration-requests': typeof AuthedIndividualPersonalCollaborationRequestsRoute
  '/_authed/_individual/personal/collaborators': typeof AuthedIndividualPersonalCollaboratorsRoute
  '/_authed/_individual/personal/dashboard': typeof AuthedIndividualPersonalDashboardRoute
  '/_authed/_individual/personal/documents': typeof AuthedIndividualPersonalDocumentsRoute
  '/_authed/_individual/personal/goals': typeof AuthedIndividualPersonalGoalsRoute
  '/_authed/_individual/personal/guided-forms': typeof AuthedIndividualPersonalGuidedFormsRoute
  '/_authed/_individual/personal/journal-invitations': typeof AuthedIndividualPersonalJournalInvitationsRouteWithChildren
  '/_authed/_individual/personal/journal-management': typeof AuthedIndividualPersonalJournalManagementRoute
  '/_authed/_individual/personal/journals': typeof AuthedIndividualPersonalJournalsRoute
  '/_authed/_professional/professional/billing': typeof AuthedProfessionalProfessionalBillingRoute
  '/_authed/_professional/professional/clients': typeof AuthedProfessionalProfessionalClientsRoute
  '/_authed/_professional/professional/invitations': typeof AuthedProfessionalProfessionalInvitationsRoute
  '/_public/sign-up/pro/': typeof PublicSignUpProIndexRoute
  '/_authed/_individual/personal/journal-invitations/accept': typeof AuthedIndividualPersonalJournalInvitationsAcceptRoute
  '/_authed/_professional/professional/goals/$estateId': typeof AuthedProfessionalProfessionalGoalsEstateIdRoute
  '/_authed/_professional/professional/guided-forms/$estateId': typeof AuthedProfessionalProfessionalGuidedFormsEstateIdRoute
  '/_authed/_professional/professional/overview/$estateId': typeof AuthedProfessionalProfessionalOverviewEstateIdRoute
  '/_authed/_professional/professional/reports/$estateId': typeof AuthedProfessionalProfessionalReportsEstateIdRoute
  '/_authed/_professional/professional/reports/insurance/$estateId': typeof AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute
  '/_authed/_professional/professional/reports/trust/$estateId': typeof AuthedProfessionalProfessionalReportsTrustEstateIdRoute
  '/_authed/_professional/professional/reports/will/$estateId': typeof AuthedProfessionalProfessionalReportsWillEstateIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/account'
    | '/dashboard'
    | '/data-deletion-agreement'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/account/emergency-contacts'
    | '/account/organization'
    | '/account/profile'
    | '/account/security'
    | '/invitation/$token'
    | '/onboarding/emergency-contacts'
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/personal/collaboration-requests'
    | '/personal/collaborators'
    | '/personal/dashboard'
    | '/personal/documents'
    | '/personal/goals'
    | '/personal/guided-forms'
    | '/personal/journal-invitations'
    | '/personal/journal-management'
    | '/personal/journals'
    | '/professional/billing'
    | '/professional/clients'
    | '/professional/invitations'
    | '/sign-up/pro'
    | '/personal/journal-invitations/accept'
    | '/professional/goals/$estateId'
    | '/professional/guided-forms/$estateId'
    | '/professional/overview/$estateId'
    | '/professional/reports/$estateId'
    | '/professional/reports/insurance/$estateId'
    | '/professional/reports/trust/$estateId'
    | '/professional/reports/will/$estateId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/account'
    | '/dashboard'
    | '/data-deletion-agreement'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/account/emergency-contacts'
    | '/account/organization'
    | '/account/profile'
    | '/account/security'
    | '/invitation/$token'
    | '/onboarding/emergency-contacts'
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/personal/collaboration-requests'
    | '/personal/collaborators'
    | '/personal/dashboard'
    | '/personal/documents'
    | '/personal/goals'
    | '/personal/guided-forms'
    | '/personal/journal-invitations'
    | '/personal/journal-management'
    | '/personal/journals'
    | '/professional/billing'
    | '/professional/clients'
    | '/professional/invitations'
    | '/sign-up/pro'
    | '/personal/journal-invitations/accept'
    | '/professional/goals/$estateId'
    | '/professional/guided-forms/$estateId'
    | '/professional/overview/$estateId'
    | '/professional/reports/$estateId'
    | '/professional/reports/insurance/$estateId'
    | '/professional/reports/trust/$estateId'
    | '/professional/reports/will/$estateId'
  id:
    | '__root__'
    | '/_authed'
    | '/_public'
    | '/_authed/_individual'
    | '/_authed/_professional'
    | '/_authed/account'
    | '/_authed/dashboard'
    | '/_public/data-deletion-agreement'
    | '/_public/privacy-policy'
    | '/_public/terms-of-service'
    | '/_authed/account/emergency-contacts'
    | '/_authed/account/organization'
    | '/_authed/account/profile'
    | '/_authed/account/security'
    | '/_authed/invitation/$token'
    | '/_authed/onboarding/emergency-contacts'
    | '/_public/_homepage/'
    | '/_public/sign-in/'
    | '/_public/sign-up/'
    | '/_authed/_individual/personal/collaboration-requests'
    | '/_authed/_individual/personal/collaborators'
    | '/_authed/_individual/personal/dashboard'
    | '/_authed/_individual/personal/documents'
    | '/_authed/_individual/personal/goals'
    | '/_authed/_individual/personal/guided-forms'
    | '/_authed/_individual/personal/journal-invitations'
    | '/_authed/_individual/personal/journal-management'
    | '/_authed/_individual/personal/journals'
    | '/_authed/_professional/professional/billing'
    | '/_authed/_professional/professional/clients'
    | '/_authed/_professional/professional/invitations'
    | '/_public/sign-up/pro/'
    | '/_authed/_individual/personal/journal-invitations/accept'
    | '/_authed/_professional/professional/goals/$estateId'
    | '/_authed/_professional/professional/guided-forms/$estateId'
    | '/_authed/_professional/professional/overview/$estateId'
    | '/_authed/_professional/professional/reports/$estateId'
    | '/_authed/_professional/professional/reports/insurance/$estateId'
    | '/_authed/_professional/professional/reports/trust/$estateId'
    | '/_authed/_professional/professional/reports/will/$estateId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/terms-of-service': {
      id: '/_public/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof PublicTermsOfServiceRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/privacy-policy': {
      id: '/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PublicPrivacyPolicyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/data-deletion-agreement': {
      id: '/_public/data-deletion-agreement'
      path: '/data-deletion-agreement'
      fullPath: '/data-deletion-agreement'
      preLoaderRoute: typeof PublicDataDeletionAgreementRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_professional': {
      id: '/_authed/_professional'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedProfessionalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_individual': {
      id: '/_authed/_individual'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedIndividualRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/sign-up/': {
      id: '/_public/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicSignUpIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/': {
      id: '/_public/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/_homepage/': {
      id: '/_public/_homepage/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicHomepageIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/onboarding/emergency-contacts': {
      id: '/_authed/onboarding/emergency-contacts'
      path: '/onboarding/emergency-contacts'
      fullPath: '/onboarding/emergency-contacts'
      preLoaderRoute: typeof AuthedOnboardingEmergencyContactsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invitation/$token': {
      id: '/_authed/invitation/$token'
      path: '/invitation/$token'
      fullPath: '/invitation/$token'
      preLoaderRoute: typeof AuthedInvitationTokenRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/security': {
      id: '/_authed/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AuthedAccountSecurityRouteImport
      parentRoute: typeof AuthedAccountRoute
    }
    '/_authed/account/profile': {
      id: '/_authed/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthedAccountProfileRouteImport
      parentRoute: typeof AuthedAccountRoute
    }
    '/_authed/account/organization': {
      id: '/_authed/account/organization'
      path: '/organization'
      fullPath: '/account/organization'
      preLoaderRoute: typeof AuthedAccountOrganizationRouteImport
      parentRoute: typeof AuthedAccountRoute
    }
    '/_authed/account/emergency-contacts': {
      id: '/_authed/account/emergency-contacts'
      path: '/emergency-contacts'
      fullPath: '/account/emergency-contacts'
      preLoaderRoute: typeof AuthedAccountEmergencyContactsRouteImport
      parentRoute: typeof AuthedAccountRoute
    }
    '/_public/sign-up/pro/': {
      id: '/_public/sign-up/pro/'
      path: '/sign-up/pro'
      fullPath: '/sign-up/pro'
      preLoaderRoute: typeof PublicSignUpProIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/_professional/professional/invitations': {
      id: '/_authed/_professional/professional/invitations'
      path: '/professional/invitations'
      fullPath: '/professional/invitations'
      preLoaderRoute: typeof AuthedProfessionalProfessionalInvitationsRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/clients': {
      id: '/_authed/_professional/professional/clients'
      path: '/professional/clients'
      fullPath: '/professional/clients'
      preLoaderRoute: typeof AuthedProfessionalProfessionalClientsRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/billing': {
      id: '/_authed/_professional/professional/billing'
      path: '/professional/billing'
      fullPath: '/professional/billing'
      preLoaderRoute: typeof AuthedProfessionalProfessionalBillingRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_individual/personal/journals': {
      id: '/_authed/_individual/personal/journals'
      path: '/personal/journals'
      fullPath: '/personal/journals'
      preLoaderRoute: typeof AuthedIndividualPersonalJournalsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/journal-management': {
      id: '/_authed/_individual/personal/journal-management'
      path: '/personal/journal-management'
      fullPath: '/personal/journal-management'
      preLoaderRoute: typeof AuthedIndividualPersonalJournalManagementRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/journal-invitations': {
      id: '/_authed/_individual/personal/journal-invitations'
      path: '/personal/journal-invitations'
      fullPath: '/personal/journal-invitations'
      preLoaderRoute: typeof AuthedIndividualPersonalJournalInvitationsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/guided-forms': {
      id: '/_authed/_individual/personal/guided-forms'
      path: '/personal/guided-forms'
      fullPath: '/personal/guided-forms'
      preLoaderRoute: typeof AuthedIndividualPersonalGuidedFormsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/goals': {
      id: '/_authed/_individual/personal/goals'
      path: '/personal/goals'
      fullPath: '/personal/goals'
      preLoaderRoute: typeof AuthedIndividualPersonalGoalsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/documents': {
      id: '/_authed/_individual/personal/documents'
      path: '/personal/documents'
      fullPath: '/personal/documents'
      preLoaderRoute: typeof AuthedIndividualPersonalDocumentsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/dashboard': {
      id: '/_authed/_individual/personal/dashboard'
      path: '/personal/dashboard'
      fullPath: '/personal/dashboard'
      preLoaderRoute: typeof AuthedIndividualPersonalDashboardRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/collaborators': {
      id: '/_authed/_individual/personal/collaborators'
      path: '/personal/collaborators'
      fullPath: '/personal/collaborators'
      preLoaderRoute: typeof AuthedIndividualPersonalCollaboratorsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_individual/personal/collaboration-requests': {
      id: '/_authed/_individual/personal/collaboration-requests'
      path: '/personal/collaboration-requests'
      fullPath: '/personal/collaboration-requests'
      preLoaderRoute: typeof AuthedIndividualPersonalCollaborationRequestsRouteImport
      parentRoute: typeof AuthedIndividualRoute
    }
    '/_authed/_professional/professional/reports/$estateId': {
      id: '/_authed/_professional/professional/reports/$estateId'
      path: '/professional/reports/$estateId'
      fullPath: '/professional/reports/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalReportsEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/overview/$estateId': {
      id: '/_authed/_professional/professional/overview/$estateId'
      path: '/professional/overview/$estateId'
      fullPath: '/professional/overview/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalOverviewEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/guided-forms/$estateId': {
      id: '/_authed/_professional/professional/guided-forms/$estateId'
      path: '/professional/guided-forms/$estateId'
      fullPath: '/professional/guided-forms/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalGuidedFormsEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/goals/$estateId': {
      id: '/_authed/_professional/professional/goals/$estateId'
      path: '/professional/goals/$estateId'
      fullPath: '/professional/goals/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalGoalsEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_individual/personal/journal-invitations/accept': {
      id: '/_authed/_individual/personal/journal-invitations/accept'
      path: '/accept'
      fullPath: '/personal/journal-invitations/accept'
      preLoaderRoute: typeof AuthedIndividualPersonalJournalInvitationsAcceptRouteImport
      parentRoute: typeof AuthedIndividualPersonalJournalInvitationsRoute
    }
    '/_authed/_professional/professional/reports/will/$estateId': {
      id: '/_authed/_professional/professional/reports/will/$estateId'
      path: '/professional/reports/will/$estateId'
      fullPath: '/professional/reports/will/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalReportsWillEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/reports/trust/$estateId': {
      id: '/_authed/_professional/professional/reports/trust/$estateId'
      path: '/professional/reports/trust/$estateId'
      fullPath: '/professional/reports/trust/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalReportsTrustEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
    '/_authed/_professional/professional/reports/insurance/$estateId': {
      id: '/_authed/_professional/professional/reports/insurance/$estateId'
      path: '/professional/reports/insurance/$estateId'
      fullPath: '/professional/reports/insurance/$estateId'
      preLoaderRoute: typeof AuthedProfessionalProfessionalReportsInsuranceEstateIdRouteImport
      parentRoute: typeof AuthedProfessionalRoute
    }
  }
}

interface AuthedIndividualPersonalJournalInvitationsRouteChildren {
  AuthedIndividualPersonalJournalInvitationsAcceptRoute: typeof AuthedIndividualPersonalJournalInvitationsAcceptRoute
}

const AuthedIndividualPersonalJournalInvitationsRouteChildren: AuthedIndividualPersonalJournalInvitationsRouteChildren =
  {
    AuthedIndividualPersonalJournalInvitationsAcceptRoute:
      AuthedIndividualPersonalJournalInvitationsAcceptRoute,
  }

const AuthedIndividualPersonalJournalInvitationsRouteWithChildren =
  AuthedIndividualPersonalJournalInvitationsRoute._addFileChildren(
    AuthedIndividualPersonalJournalInvitationsRouteChildren,
  )

interface AuthedIndividualRouteChildren {
  AuthedIndividualPersonalCollaborationRequestsRoute: typeof AuthedIndividualPersonalCollaborationRequestsRoute
  AuthedIndividualPersonalCollaboratorsRoute: typeof AuthedIndividualPersonalCollaboratorsRoute
  AuthedIndividualPersonalDashboardRoute: typeof AuthedIndividualPersonalDashboardRoute
  AuthedIndividualPersonalDocumentsRoute: typeof AuthedIndividualPersonalDocumentsRoute
  AuthedIndividualPersonalGoalsRoute: typeof AuthedIndividualPersonalGoalsRoute
  AuthedIndividualPersonalGuidedFormsRoute: typeof AuthedIndividualPersonalGuidedFormsRoute
  AuthedIndividualPersonalJournalInvitationsRoute: typeof AuthedIndividualPersonalJournalInvitationsRouteWithChildren
  AuthedIndividualPersonalJournalManagementRoute: typeof AuthedIndividualPersonalJournalManagementRoute
  AuthedIndividualPersonalJournalsRoute: typeof AuthedIndividualPersonalJournalsRoute
}

const AuthedIndividualRouteChildren: AuthedIndividualRouteChildren = {
  AuthedIndividualPersonalCollaborationRequestsRoute:
    AuthedIndividualPersonalCollaborationRequestsRoute,
  AuthedIndividualPersonalCollaboratorsRoute:
    AuthedIndividualPersonalCollaboratorsRoute,
  AuthedIndividualPersonalDashboardRoute:
    AuthedIndividualPersonalDashboardRoute,
  AuthedIndividualPersonalDocumentsRoute:
    AuthedIndividualPersonalDocumentsRoute,
  AuthedIndividualPersonalGoalsRoute: AuthedIndividualPersonalGoalsRoute,
  AuthedIndividualPersonalGuidedFormsRoute:
    AuthedIndividualPersonalGuidedFormsRoute,
  AuthedIndividualPersonalJournalInvitationsRoute:
    AuthedIndividualPersonalJournalInvitationsRouteWithChildren,
  AuthedIndividualPersonalJournalManagementRoute:
    AuthedIndividualPersonalJournalManagementRoute,
  AuthedIndividualPersonalJournalsRoute: AuthedIndividualPersonalJournalsRoute,
}

const AuthedIndividualRouteWithChildren =
  AuthedIndividualRoute._addFileChildren(AuthedIndividualRouteChildren)

interface AuthedProfessionalRouteChildren {
  AuthedProfessionalProfessionalBillingRoute: typeof AuthedProfessionalProfessionalBillingRoute
  AuthedProfessionalProfessionalClientsRoute: typeof AuthedProfessionalProfessionalClientsRoute
  AuthedProfessionalProfessionalInvitationsRoute: typeof AuthedProfessionalProfessionalInvitationsRoute
  AuthedProfessionalProfessionalGoalsEstateIdRoute: typeof AuthedProfessionalProfessionalGoalsEstateIdRoute
  AuthedProfessionalProfessionalGuidedFormsEstateIdRoute: typeof AuthedProfessionalProfessionalGuidedFormsEstateIdRoute
  AuthedProfessionalProfessionalOverviewEstateIdRoute: typeof AuthedProfessionalProfessionalOverviewEstateIdRoute
  AuthedProfessionalProfessionalReportsEstateIdRoute: typeof AuthedProfessionalProfessionalReportsEstateIdRoute
  AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute: typeof AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute
  AuthedProfessionalProfessionalReportsTrustEstateIdRoute: typeof AuthedProfessionalProfessionalReportsTrustEstateIdRoute
  AuthedProfessionalProfessionalReportsWillEstateIdRoute: typeof AuthedProfessionalProfessionalReportsWillEstateIdRoute
}

const AuthedProfessionalRouteChildren: AuthedProfessionalRouteChildren = {
  AuthedProfessionalProfessionalBillingRoute:
    AuthedProfessionalProfessionalBillingRoute,
  AuthedProfessionalProfessionalClientsRoute:
    AuthedProfessionalProfessionalClientsRoute,
  AuthedProfessionalProfessionalInvitationsRoute:
    AuthedProfessionalProfessionalInvitationsRoute,
  AuthedProfessionalProfessionalGoalsEstateIdRoute:
    AuthedProfessionalProfessionalGoalsEstateIdRoute,
  AuthedProfessionalProfessionalGuidedFormsEstateIdRoute:
    AuthedProfessionalProfessionalGuidedFormsEstateIdRoute,
  AuthedProfessionalProfessionalOverviewEstateIdRoute:
    AuthedProfessionalProfessionalOverviewEstateIdRoute,
  AuthedProfessionalProfessionalReportsEstateIdRoute:
    AuthedProfessionalProfessionalReportsEstateIdRoute,
  AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute:
    AuthedProfessionalProfessionalReportsInsuranceEstateIdRoute,
  AuthedProfessionalProfessionalReportsTrustEstateIdRoute:
    AuthedProfessionalProfessionalReportsTrustEstateIdRoute,
  AuthedProfessionalProfessionalReportsWillEstateIdRoute:
    AuthedProfessionalProfessionalReportsWillEstateIdRoute,
}

const AuthedProfessionalRouteWithChildren =
  AuthedProfessionalRoute._addFileChildren(AuthedProfessionalRouteChildren)

interface AuthedAccountRouteChildren {
  AuthedAccountEmergencyContactsRoute: typeof AuthedAccountEmergencyContactsRoute
  AuthedAccountOrganizationRoute: typeof AuthedAccountOrganizationRoute
  AuthedAccountProfileRoute: typeof AuthedAccountProfileRoute
  AuthedAccountSecurityRoute: typeof AuthedAccountSecurityRoute
}

const AuthedAccountRouteChildren: AuthedAccountRouteChildren = {
  AuthedAccountEmergencyContactsRoute: AuthedAccountEmergencyContactsRoute,
  AuthedAccountOrganizationRoute: AuthedAccountOrganizationRoute,
  AuthedAccountProfileRoute: AuthedAccountProfileRoute,
  AuthedAccountSecurityRoute: AuthedAccountSecurityRoute,
}

const AuthedAccountRouteWithChildren = AuthedAccountRoute._addFileChildren(
  AuthedAccountRouteChildren,
)

interface AuthedRouteChildren {
  AuthedIndividualRoute: typeof AuthedIndividualRouteWithChildren
  AuthedProfessionalRoute: typeof AuthedProfessionalRouteWithChildren
  AuthedAccountRoute: typeof AuthedAccountRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedInvitationTokenRoute: typeof AuthedInvitationTokenRoute
  AuthedOnboardingEmergencyContactsRoute: typeof AuthedOnboardingEmergencyContactsRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedIndividualRoute: AuthedIndividualRouteWithChildren,
  AuthedProfessionalRoute: AuthedProfessionalRouteWithChildren,
  AuthedAccountRoute: AuthedAccountRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedInvitationTokenRoute: AuthedInvitationTokenRoute,
  AuthedOnboardingEmergencyContactsRoute:
    AuthedOnboardingEmergencyContactsRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicRouteChildren {
  PublicDataDeletionAgreementRoute: typeof PublicDataDeletionAgreementRoute
  PublicPrivacyPolicyRoute: typeof PublicPrivacyPolicyRoute
  PublicTermsOfServiceRoute: typeof PublicTermsOfServiceRoute
  PublicHomepageIndexRoute: typeof PublicHomepageIndexRoute
  PublicSignInIndexRoute: typeof PublicSignInIndexRoute
  PublicSignUpIndexRoute: typeof PublicSignUpIndexRoute
  PublicSignUpProIndexRoute: typeof PublicSignUpProIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicDataDeletionAgreementRoute: PublicDataDeletionAgreementRoute,
  PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,
  PublicTermsOfServiceRoute: PublicTermsOfServiceRoute,
  PublicHomepageIndexRoute: PublicHomepageIndexRoute,
  PublicSignInIndexRoute: PublicSignInIndexRoute,
  PublicSignUpIndexRoute: PublicSignUpIndexRoute,
  PublicSignUpProIndexRoute: PublicSignUpProIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
